import { ConfirmDelete } from "components/ConfirmDialog/ConfirmDelete";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { useApi } from "providers";
import { useDocument } from "providers";
import { useToasts } from "providers";
import { useTranslations } from "providers";
import { useMeeting } from "providers";
import { useCallback } from "react";

export const ConfirmDeleteDocument: React.FC = () => {
  const i18n = useTranslations();
  const toasts = useToasts();
  const { reloadMeeting } = useMeeting();
  const { workingDocumentsApi } = useApi();
  const { confirmDeleteDocument, setConfirmDeleteDocument, setDocumentDeleting } = useDocument();

  const isOpen = confirmDeleteDocument !== undefined;

  const handleDelete = useCallback(
    async (target?: ConfirmDeleteTarget) => {
      if (!target) return;

      setConfirmDeleteDocument(undefined);
      setDocumentDeleting(target.id, true);

      try {
        await workingDocumentsApi.delete(target.id);
      } catch (error) {
        toasts.deleteFailure(i18n.WorkingDocument, target.title, error);
      } finally {
        reloadMeeting().finally(() => {
          setDocumentDeleting(target.id, false);
        });
      }
    },
    [workingDocumentsApi, reloadMeeting, setDocumentDeleting, setConfirmDeleteDocument, i18n, toasts]
  );

  const setIsOpen = useCallback(
    (open: boolean) => {
      if (!open) {
        setConfirmDeleteDocument(undefined);
      }
    },
    [setConfirmDeleteDocument]
  );

  return (
    <ConfirmDelete
      entityName={i18n.WorkingDocument}
      entityTitle={confirmDeleteDocument?.title}
      content={i18n.Actions_Delete_Document_Confirm}
      onAccept={() => handleDelete(confirmDeleteDocument)}
      onCancel={() => setConfirmDeleteDocument(undefined)}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};
